// extracted by mini-css-extract-plugin
export default {"header":"styles_header__bLI_4"};